import React from 'react';
import { useQuery } from '@apollo/client';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField } from 'components/form';

import { DealSheetRulesFilters } from './index';
import { dealSheetConfigurationApi } from '../../../../api';

export const Country = () => {
  const { control } = useFormContext<DealSheetRulesFilters>();

  const { data: countriesResponse, loading: countriesLoading } = useQuery(dealSheetConfigurationApi.getCountries);
  const countries = countriesResponse?.dealSheets?.result?.list ?? [];

  return (
    <AutocompleteField
      multiple
      size="small"
      name="COUNTRY"
      control={control}
      options={countries}
      disableCloseOnSelect
      loading={countriesLoading}
      textFieldProps={{ variant: 'outlined', label: 'Country' }}
    />
  );
};
